import {SET_ERROR, CLEAR_ERRORS, LOGIN, LOGOUT, VALID_TOKEN, INVALID_TOKEN, TOGGLE_SIDEBAR_NAV, CLOSE_SIDEBAR_NAV, SET_NOTIFICATION, CLEAR_NOTIFICATION, SET_FORM_TEMPLATE, CLEAR_FORM_TEMPLATE, BEGIN_REQUEST, END_REQUEST, RESIZE_WINDOW} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

export default function flagshipMain(state = initialState.main, action) {
    let newState = objectAssign({}, state);

    switch (action.type) {
        case SET_ERROR:
            newState.errors = [...newState.errors, action.message];
            return newState;
        case CLEAR_ERRORS:
            newState.errors = [];
            return newState;
        case SET_NOTIFICATION:
            newState.notification = {
                message: action.payload.message,
                type: action.payload.type,
                show: true
            };
            return newState;
        case CLEAR_NOTIFICATION:
            newState.notification = initialState.main.notification;
            return newState;

        case LOGIN:
            newState.isLoggedIn = true;
            newState.token = action.token;
            newState.username = action.username;
            newState.userFirstName = action.userFirstName;
            newState.userLastName = action.userLastName;
            newState.userId = parseInt(action.userId);
            newState.userPhoto = action.userPhoto;
            newState.userRole = action.userRole;
            newState.userMarket = action.userMarket;
            localStorage.setItem("flagshipToken",action.token);
            return newState;
        case LOGOUT:
            newState.isLoggedIn = false;
            newState.token = null;
            newState.accessLevel = 0;
            newState.userPhoto = null;
            newState.userFirstName = "Unauthorized";
            newState.userLastName = "User";
            newState.userRole = "None";
            newState.userMarket = "Unknown";
            localStorage.removeItem("flagshipToken");
            return newState;
        case VALID_TOKEN:
            newState.isLoggedIn = true;
            newState.token = action.token;
            newState.username = action.username;
            newState.userFirstName = action.userFirstName;
            newState.userLastName = action.userLastName;
            newState.userId = parseInt(action.userId);
            newState.userPhoto = action.username + '.jpg?cb_' + Math.floor(Math.random() * 999999);
            newState.userRole = action.userRole;
            newState.userMarket = action.userMarket;
            newState.accessLevel = action.accessLevel;
            return newState;
        case INVALID_TOKEN:
            newState.isLoggedIn = false;
            newState.token = null;
            newState.userName = '';
            newState.accessLevel = 0;
            newState.userPhoto = null;
            newState.userFirstName = "Unauthorized";
            newState.userLastName = "User";
            newState.userRole = "None";
            newState.userMarket = "Unknown";
            return newState;
        case TOGGLE_SIDEBAR_NAV:
            newState.sidebarNavActive = !newState.sidebarNavActive;
            return newState;
        case SET_FORM_TEMPLATE:
            newState.formTemplate = objectAssign(action.payload.data, newState.formTemplate);
            return newState;
        case CLEAR_FORM_TEMPLATE:
            newState.formTemplate = {};
            return newState;
        case CLOSE_SIDEBAR_NAV:
            newState.sidebarNavActive = false;
            return newState;
        case BEGIN_REQUEST:
            newState.makingRequest = true;
            return newState;
        case END_REQUEST:
            newState.makingRequest= false;
            return newState;
        case RESIZE_WINDOW:
            newState.screenWidth = action.size;
            return newState;
        default:
            return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js